interface ProgressCircleProps {
  current: number
  total: number
  size?: number
}

const ProgressCircle = ({ current, total, size = 16 }: ProgressCircleProps) => {
  const percentage = total > 0 ? Math.min(Math.max((current / total) * 100, 15), 100) : 15
  const strokeWidth = size <= 16 ? 2 : 3
  const innerSize = size - strokeWidth * 2

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `conic-gradient(
          #06838B 0%,
          #06838B ${String(percentage)}%,
          #E5E7EB ${String(percentage)}%,
          #E5E7EB 100%
        )`,
      }}
    >
      <div
        style={{
          width: innerSize,
          height: innerSize,
          borderRadius: '50%',
          backgroundColor: '#FFFFFF',
        }}
      />
    </div>
  )
}

export default ProgressCircle
